import { secondaryFontFamily, styled } from '@openeducation/oe-rn-themes';
import React from 'react';
import { StyleProp, ViewStyle } from 'react-native';

import { OEText } from '../oe-text/oe-text';
import { OETouchableOpacity } from '../oe-touchable-opacity/oe-touchable-opacity';

export interface ToggleSwitchButtonProps {
  containerStyle?: StyleProp<ViewStyle>;
  onChange: (value: boolean) => void;
  value: boolean;
  label?: string;
  showLabel?: boolean;
}

export function ToggleSwitchButton({
  containerStyle,
  onChange,
  value,
  label,
  showLabel = !!label,
}: ToggleSwitchButtonProps) {
  return (
    <Container style={containerStyle}>
      {showLabel && <Label>{label}</Label>}
      <ButtonContainer onPress={() => onChange(!value)}>
        <Circle enabled={value} />
      </ButtonContainer>
    </Container>
  );
}

interface EnabledProps {
  enabled: boolean;
}

const Container = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const Label = styled(OEText).attrs({
  fontFamily: secondaryFontFamily,
  fontType: 'medium',
})`
  font-size: 12px;
  line-height: 12px;
  font-weight: bold;
  color: ${({ theme }) => theme.color.black};
`;

const ButtonContainer = styled(OETouchableOpacity)`
  width: 38px;
  border-radius: 16px;
  background-color: ${({ theme }) => theme.color.light1};
  padding: 2px;
  justify-content: center;
`;

const Circle = styled.View<EnabledProps>`
  width: 18px;
  height: 18px;
  border-radius: 18px;
  background-color: ${({ theme, enabled }) =>
    enabled ? theme.color.sunnyOrange : theme.color.dark3};
  align-self: ${({ enabled }) => (enabled ? 'flex-end' : 'flex-start')};
`;
